import Vue from 'vue';
import * as C from '../constants';

export default {

  /**
   * Sets session info in state.
   *
   * @param state
   * @param payload
   */
  [C.APP_SESSION_INFO_SET](state, { user, brands, products, suppliers }) {
    Vue.set(state, 'auth', {
      ...state.auth,
      user,
      brands,
      products,
      suppliers,
      session: true,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js